import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import Accordion from "@mui/material/Accordion";
import {
    EventNoteOutlined,
    AccessTimeFilledOutlined,
    Delete,
    BorderColor,
    Margin
} from "@mui/icons-material";

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { AccessTime, Event } from "@mui/icons-material";
import { VerResultados } from '../../pages/Encuestas/EncuestaResultados'
import { useDispatch } from "react-redux";
import { Button, CardContent, Typography, Grid } from "@mui/material";
import { CardHeader } from "reactstrap";
import { Navigate, useNavigate } from "react-router";
import RequiredPermission from "../../authentication/RequiredPermission";
import { selectEmpleado, selectEmpleadoDashboard } from "../../redux/Empleados/EmpleadosSlice";
import { PermissionData } from "../../context/Component/PermissionData";
import swal from "sweetalert";
import { fetchCambiarEstadoEncuesta, fetchGenerarGanadoresCriterios } from "../../redux/Encuestas/EncuestasSlice";

const EncuestaCard = ({ encuesta }) => {

    // ? HOOK-DISPATCH
    const dispatch = useDispatch();

    const navigate = useNavigate();
    const permisosState = PermissionData();

    const [estado, setEstado] = useState(encuesta.estado)

    const navigateEncuestasVotar = (encuesta) => {
        navigate(`/encuesta/encuestas/votar/${encuesta.encuestaId}`, { state: encuesta });
    }

    const verResultados = (encuesta) => {
        navigate(`/encuesta/encuestas/resultados/${encuesta.encuestaId}`, { state: encuesta })

    }

    const formatFecha = (fecha) => {
        if (!fecha) return "Indefinido";
        return new Date(fecha).toLocaleString("es-DO", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        });
    };

    const handleCambioEstado = (encuestaId) => {
        swal({
            title: `Seguro/a que desea ${estado == true ? "deshabilitar" : "habilitar"} la encuesta?`,
            icon: "warning",
            buttons: ["Cancelar", "Confirmar"]
        }).then((respuesta) => {
            if (respuesta) {
                dispatch(fetchCambiarEstadoEncuesta(encuestaId))
                .then(() => {
                    setEstado(!estado);
                    swal({
                        title: "Se ha cambiado el estado de la encuesta",
                        icon: "success",
                        button: "Aceptar"
                    })
                })
                .catch((error) => {     
                    swal({
                        title: "Error",
                        text: "Ocurrió un problema al cambiar el estado. Intente nuevamente.",
                        icon: "error",
                        button: "Aceptar"
                    });
                });
            }
        })
    }

     const handleGenerarGanadores = () => {
        swal({
            title: `Seguro/a que desea generar los ganadores de la encuesta?`,
            icon: "warning",
            buttons: ["Cancelar", "Confirmar"]
        }).then((respuesta) => {
            if (respuesta) {
                dispatch(fetchGenerarGanadoresCriterios())
            }
        })
    }

    const {
        titulo,
        descripcion,
        fechaInicio,
        fechaFin,
        tipoEncuesta,
        encuestaId,
    } = encuesta
    
    return (
        <Box sx={{ height: "100%" }}>
            <Card style={{ display: "flex", flexDirection: "column", height: "100%", textAlign: "center", minWidth: '500px', maxWidth: '500px' }}>
                <CardHeader style={{ minHeight: '80px', display: "flex", justifyContent: "center", alignItems: "center", flexGrow: 1 }}>
                    <Typography variant="h6" fontWeight="bold">
                        {titulo}
                    </Typography>
                </CardHeader>
                <CardContent style={{ flexDirection: "column", alignItems: "center", justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        {descripcion}
                    </Typography>

                    <Typography variant="body2" fontWeight="bold" color="primary" sx={{ mb: 1 }}>
                        Tipo de encuesta: {tipoEncuesta}
                    </Typography>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, alignItems: "center" }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Event fontSize="small" color="action" />
                            <Typography variant="body2" color="text.secondary">
                                Fecha de inicio: {formatFecha(fechaInicio)}
                            </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <AccessTime fontSize="small" color="action" />
                            <Typography variant="body2" color="text.secondary">
                                Fecha de finalización: {formatFecha(fechaFin)}
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ mt: 3, display: "flex", flexDirection: "column", gap: 1, width: "100%" }}>
                        <Button variant="contained" fullWidth onClick={() => navigateEncuestasVotar(encuesta)} disabled={!estado}>
                            Participar
                        </Button>

                        {permisosState.ROLE_VER_RESULTADOS_ENCUESTA &&

                            <Button variant="outlined" fullWidth onClick={() => verResultados(encuesta)}>
                                Ver Resultados
                            </Button>
                        }

                        {permisosState.ROLE_ADMINISTRADOR_ENCUESTA && estado ? (
                            <>
                                <Button variant='contained' fullWidth color="error" onClick={() => handleCambioEstado(encuestaId)}>
                                    Deshabilitar Encuesta
                                </Button>
                                
                            </>
                        ) : (
                            permisosState.ROLE_ADMINISTRADOR_ENCUESTA && (
                               <>
                                    <Button variant="contained" fullWidth color='success' onClick={() => handleCambioEstado(encuestaId)}>
                                        Habilitar encuesta
                                    </Button>
                                    <button hidden={!encuesta.criteriosHabilitado} className="btn btn-primary" onClick={() => handleGenerarGanadores()}>
                                        Generar Ganadores 2da Encuesta
                                    </button>
                               </>
                            )
                        )}

                    </Box>
                </CardContent>
            </Card>
        </Box>

    )
}

export default EncuestaCard;